__turbopack_context__.v({
  "background": "global-transition-module__Z2NRkG__background",
  "container": "global-transition-module__Z2NRkG__container",
});
